export default __webpack_public_path__ + "static/media/instagram.7a8a15b2.svg";